module.exports = __webpack_public_path__ + "img/statistics-bg-1.952f9e24.png";